import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m9.48 12.193 1.68 1.68 3.36-3.36M8.5 6.057a2.874 2.874 0 0 0 1.636-.677 2.874 2.874 0 0 1 3.728 0c.46.392 1.033.63 1.636.677a2.874 2.874 0 0 1 2.636 2.637c.048.603.285 1.175.677 1.635a2.874 2.874 0 0 1 0 3.728 2.875 2.875 0 0 0-.677 1.636 2.874 2.874 0 0 1-2.636 2.636 2.874 2.874 0 0 0-1.636.678 2.874 2.874 0 0 1-3.728 0 2.874 2.874 0 0 0-1.636-.678 2.874 2.874 0 0 1-2.636-2.636 2.874 2.874 0 0 0-.677-1.636 2.874 2.874 0 0 1 0-3.728c.392-.46.629-1.032.677-1.635A2.874 2.874 0 0 1 8.5 6.057Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };